const getEnvironmentConfig = () => {
  const environment = process.env.REACT_APP_ENV || "production";
  if (environment === "production") {
    return {
      API_KEY: process.env.REACT_APP_API_KEY_PROD as string,
      BASE_API_URL: process.env.REACT_APP_API_ENDPOINT_PROD as string,
      AGORA_APP_ID: process.env.REACT_APP_AGORA_APP_ID_PROD as string,
      API_BASE_URL: process.env.REACT_APP_API_BASE_URL_PROD as string,
      REACT_APP_ENV: 'prod',

    };
  } else if (environment === "development") {
    return {
      API_KEY: process.env.REACT_APP_API_KEY as string,
      BASE_API_URL: process.env.REACT_APP_API_ENDPOINT as string,
      AGORA_APP_ID: process.env.REACT_APP_AGORA_APP_ID as string,
      API_BASE_URL: process.env.REACT_APP_API_BASE_URL as string,
      REACT_APP_ENV: 'staging',
    };
  } else {
    // Add default or development environment config here
    return {
      API_KEY: "",
      BASE_API_URL: "",
      AGORA_APP_ID: "",
      REACT_APP_ENV: "",
      API_BASE_URL: ""
    };
  }
};

export const { API_KEY, BASE_API_URL, AGORA_APP_ID, REACT_APP_ENV, API_BASE_URL } = getEnvironmentConfig();
